// extracted by mini-css-extract-plugin
module.exports = {"pin":"__8aU6XBe5","bg":"__9OMpHXUA"};